import { OutputType } from '@/app/constants/outputType'
import DatePickerRangeButton from '@/modules/drivers/shared/datepickers/DatePickerRangeButton'
import { DatePickerRangeProps } from '@/modules/drivers/types'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import { CompanyNameBadge } from '@/modules/drivers/shared/viewBars/CompanyNameBadge'
import * as React from 'react'

interface HeadBarProps {
  title: string
  icon: React.ReactElement
  handleDateRangeChange: (dateRange: DatePickerRangeProps) => void
  range: DatePickerRangeProps
  outputType: OutputType
  setOutputType: (type: OutputType) => void
}

export const HeadBar = ({
  title,
  icon,
  outputType,
  setOutputType,
  handleDateRangeChange,
  range,
}: HeadBarProps) => {
  const { t } = useLocalize()
  return (
    <div className="tw-items-left tw-flex tw-gap-6 tw-rounded-t-xl tw-border-b tw-p-4">
      <CompanyNameBadge />
      <div className="tw-flex tw-items-center tw-rounded-t-xl">
        <div className="tw-mr-1">{icon}</div>
        <div className="tw-flex-1 tw-text-xl tw-font-semibold">{title}</div>
      </div>
      <div className="tw-flex tw-items-center tw-gap-3">
        <p className="tw-color-content-base tw-font-sm">{t('common.date-range')}</p>
        <DatePickerRangeButton
          iconAlign="left"
          size="small"
          highlightSelected={true}
          onChange={handleDateRangeChange}
          initialDate={range}
          clearable={false}
        />
      </div>
      <div className="tw-flex tw-items-center tw-gap-3">
        <p className="tw-color-content-base tw-font-sm">{t('printout.format')}</p>
        <label className="tw-m-0 tw-flex tw-cursor-pointer tw-items-center tw-gap-2 ">
          <input
            type="radio"
            name="outputFormat"
            checked={outputType === OutputType.Pdf}
            onChange={() => setOutputType(OutputType.Pdf)}
            className="tw-h-4 tw-w-4 tw-cursor-pointer tw-accent-primary"
          />
          <span className="tw-text-sm tw-text-content-base">
            {t('menu.printout-pdf')}
          </span>
        </label>
        <label className="tw-m-0 tw-flex tw-cursor-pointer tw-items-center tw-gap-2 ">
          <input
            type="radio"
            name="outputFormat"
            checked={outputType === OutputType.Csv}
            onChange={() => setOutputType(OutputType.Csv)}
            className="tw-h-4 tw-w-4 tw-cursor-pointer tw-accent-primary"
          />
          <span className="tw-text-sm tw-text-content-base">
            {t('menu.printout-csv')}
          </span>
        </label>
      </div>
    </div>
  )
}
